import { Injectable } from "@angular/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

@Injectable({providedIn:'root'})
export class ModalWrapperService {
    constructor(private modalService: NgbModal) { }

    open(modalContent: any,customClass?:any,centered =false,size=''): NgbModalRef {
        const modalOptions: NgbModalOptions = {
            modalDialogClass: customClass,
            centered:centered,
            animation: true,
            fullscreen: false,
            size
        };
        const modalRef = this.modalService.open(modalContent, modalOptions);
        return modalRef;
    }
}
